export default {
  // Login.vue
  'E-Funeral': 'E-Funeral',
  'Email address': 'Adresse email',
  'Password': 'Mot de passe',
  'Wrong username or password.': 'L’adresse e-mail ou le mot de passe que vous avez encodé n’est pas correct.',
  'Login': 'Se connecter',
  'Unnamed Video': 'Vidéo sans nom'
}
